import { Tab, Tabs } from "@blueprintjs/core"
import { observer } from "mobx-react"
import { Page } from "modules/common/components/page/Page"
import func from "modules/orders-manage/functionalities"
import { menuItems } from "modules/root/components/menu/MainMenu"
import { canAny } from "modules/session/auth/access"
import { SessionType } from "modules/session/auth/models/session"
import React, { useEffect, useState } from "react"
import { useParams } from "react-router";
import { OrderQuestionStoreType } from "../models/store"
import styles from "./QuestionsPage.module.scss"
import { QuestionsList } from "./QuestionsList"
import { QuestionsTab } from "./Tab"

const menu = menuItems()

/** Сколько гаснет прежний вид — столько же, сколько transition .fadeOut в QuestionsPage.module.scss */
const VIEW_FADE_MS = 150

export const OrderQuestionsPage: React.FC<OrderQuestionsPageProps> = observer(({ store, session, view }) => {
  const current = view === "list" ? "list" : "board"

  // доска и список — разные маршруты одной страницы. При смене вида прежний плавно гаснет,
  // затем новый проявляется целиком. Открытие трекера из меню — без анимации
  const [shownView, setShownView] = useState(current)
  const [fading, setFading] = useState(false)
  const [switched, setSwitched] = useState(false)

  useEffect(() => {
    if (shownView === current) {
      return
    }

    setFading(true)

    const timer = window.setTimeout(() => {
      setShownView(current)
      setFading(false)
      setSwitched(true)
    }, VIEW_FADE_MS)

    return () => window.clearTimeout(timer)
  }, [current, shownView])

  const canManage = canAny([func.ORDERS_QUESTION_EDIT, func.ORDERS_QUESTION_FULL_ACCESS], session.access)

  // задание из пути /order-questions/<id>: открывается сразу на своей доске
  const { questionId = "" } = useParams<{ questionId?: string }>()

  // вкладка браузера называется по открытому заданию: закладка на него узнаваема
  const opened = questionId && store.question.id === questionId ? store.question.number : ""

  useEffect(() => {
    document.title = opened ? `${menu.orderQuestions.label} — ${opened}` : menu.orderQuestions.label
  }, [opened])

  return (
    <Page className={styles.page}>
      <Tabs
        className={`${styles.tabs} planr-tabs-navigation`}
        id="OrderQuestionsPage"
        selectedTabId="1"
        renderActiveTabPanelOnly={true}
      >
        <Tab
          id="1"
          title={menu.orderQuestions.label}
          panel={
            // ключ по виду: обёртка новая — проявление запускается заново при каждой смене
            <div
              key={shownView}
              className={`${styles.view} ${fading ? styles.fadeOut : switched ? styles.fadeIn : ""}`}
            >
            {shownView === "list" ? (
              // все задания всех досок одним списком — как поиск задач в Jira
              <QuestionsList
                store={store}
                currentUserId={session.userId}
                canManage={canManage}
                canAddQuestion={canManage}
                questionId={questionId}
              />
            ) : (
              <QuestionsTab
                store={store}
                currentUserId={session.userId}
                canManage={canManage}
                canAddQuestion={canManage}
                questionId={questionId}
                isActiveTab
              />
            )}
            </div>
          }
        />
      </Tabs>
    </Page>
  )
})

interface OrderQuestionsPageProps {
  store: OrderQuestionStoreType
  session: SessionType
  /** list — список заданий по всем доскам, иначе доска */
  view?: "board" | "list"
}
